export function slugifyBundleTitle(value: string): string {
    return value
        .normalize("NFKD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .trim()
        .replace(/['’]/g, "")
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
}

export function getBundleSlug(slug: unknown, title: unknown): string {
    if (typeof slug === "string" && slug.trim()) {
        return slug.trim();
    }

    return typeof title === "string" ? slugifyBundleTitle(title) : "";
}

export function withGeneratedBundleSlug<T extends {slug?: unknown; title?: unknown}>(
    onFinish?: (values: T) => unknown
) {
    return (values: T) => onFinish?.({
        ...values,
        slug: getBundleSlug(values.slug, values.title),
    });
}
